module.exports = {
  clientId: "ZjlI42O6X8XCft6E0SZow1TfpByYqminACxzWtEdKYM",
  clientSecret: "rKLYQz5qdJPRE2rzTr1_TR9aD6JTmiGMSHDfQT4VOTY",
  originUrl: "https://commerce-layer-be.prod.exelab.net",
  scope: "market:13821",
};
